
export function addClass(el, className) {
    el.classList.add(className);
}

export function removeClass(el, className) {
    el.classList.remove(className);
}

